(function() {
	/******************
		* This is a basic helper method that returns the number of visible pixels an element has in the viewport
		* Usage Example:
			var visHeight = blue.meth.inViewport(element)
			//visHeight -> 32px
	******************/
	const checkVisible = blue.meth.checkVisible = (elm, axis = "both") => {
		let rect = elm.getBoundingClientRect();
		let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
		let viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
	
		if (axis == "both") {
			return rect.left >= 0 && (rect.right - viewWidth < 0) && rect.top >= 0 && (rect.bottom - viewHeight < 0)
		} else if (axis == "y") {
			return rect.top >= 0 && (rect.bottom - viewHeight < 0)
		} else if (axis == "x") {
			return rect.left >= 0 && (rect.right - viewWidth < 0)
		}
	};
})();